/**
HOW THIS FILE WORKS AND WHAT IT DOES
-----------------------------------

Since we use turbolinks for navigation we can make use of navigo's default HTML5 history navigation.
Instead navigo's HTML5 history navigation is used only on the first page load (or in a refresh).

To create a hybrid implementation, we register a wildcard route in navigo in order to resolve the namespaces based on
the controller/action pair. Which means, every route on navigo takes precedence over a Namespace route.

When Turbolinks event turbolinks:load is triggered we start to process the route on the Router.load() method. This
method will take those steps:

- Check if the current url is the same visited before.
 -  If so, a `?force=<uuid>` is added to the URL to make possible navigo trigger the route again.
 - This is required for pages that have view change based on #, for instance: stores#payment_devices and stores#details.
- Calls the Initializer to register any React components present on DOM
- Resumes navigo routing (previously paused in another run)
-  Forces to resolve to the current with (with force parameter or not)
-  Resumes the routing
-  Stores current URL as previous url to a future check

If the URL matches a registered route in navigo, it will be called.
*/

import EventsFallback from './lib/events_fallback';
import UserSession from './views/content/footer/user_session.js';
import EditableForm from './views/components/editableForm.js';
import Routes from '../routes.js';
import ContentRegion from './contentRegion.js';
import Initializer from './components/Initializer.js';
import * as uuid from 'uuid';

export default class Router extends EventsFallback {
  constructor(...args) {
    super(...args);

    this.forceRoute = false;
    this.contentRegion = new ContentRegion();
    this.contentRegion.start();
    this.editableForm = new EditableForm();
    this.userSession = new UserSession();

    this.oldURL = location.href;
    this.router = Routes();
    this.router.notFound(() => this._route());
    this.loading = false;
    this.previousURL = location.href;
    this.initializer = new Initializer();

    $(document).on('turbolinks:render', () => this.initializer.register());
    $(document).on('turbolinks:before-render', () =>
      this.initializer.unregister(),
    );

    document.addEventListener('turbolinks:before-visit', (e) => {
      if (this.loading) {
        e.preventDefault();
      }
      this.loading = true;
    });

    document.addEventListener('turbolinks:request-start', (event) => {
      var csrf = $('meta[name=csrf-token]').attr('content');
      if (csrf) {
        event.data.xhr.setRequestHeader('X-CSRF-Token', csrf);
      }
    });

    $(document).on('ajax:error', 'form', (e, xhr, status) => {
      var hash = location.hash;

      this.initializer.unregister();
      $('#main-content').html($('#main-content', $(xhr.responseText)).html());
      this.initializer.register();
      this.contentRegion.onError(xhr, status);
      if (location.hash) {
        location.hash = '';
        location.hash = hash;
      }
      $('.field_with_errors input:first').trigger('focus');
      this.emit('error');
    });

    this._focusFirstInvalidField();
  }

  load() {
    var force =
        this.previousURL.indexOf('?') > -1
          ? `&force=${uuid.v4()}`
          : `?force=${uuid.v4()}`,
      currentLocation = location.href,
      url =
        this.previousURL != currentLocation
          ? currentLocation
          : `${this.previousURL}${force}`;

    this.initializer.register();
    this.router.resume();
    this.router.resolve(url);
    this.router.pause();
    this.editableForm.destroy();
    this.editableForm.initialize();
    this.loading = false;
    this.previousURL = url;
  }

  _route() {
    var contentData = $('#main-content').data(),
      controller = contentData['controller'],
      action = contentData['action'],
      namespace = ['IO', 'Views', controller, action].join('.'),
      view = getModule(namespace);

    console.log('Routing to', namespace);
    this.contentRegion.load(view);

    if (controller === 'Sessions' || controller.indexOf('Devise') !== -1) {
      this.userSession.erase();
    } else {
      this.userSession.updateTime();
    }

    this.emit('route');
    this.editableForm.destroy();
    this.editableForm.initialize();
  }

  _focusFirstInvalidField() {
    setTimeout(() => {
      $('input.error').first().trigger('focus');
    }, 100);
  }
}
